import React from 'react';

import styled from 'types/AppTheme';

import styles from './RadioButton.module.scss';

interface IRadioButtonProps
  extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  labelText: string;
}

const StyledLabel = styled.label`
  & > input {
    display: none;
  }

  &:has(input:checked) {
    background-color: ${({ theme }) => theme.colors.brandColor};
    color: ${({ theme }) => theme.colors.white100Base};
    border-color: ${({ theme }) => theme.colors.brandColor};
  }
`;

const RadioButton = ({ labelText, ...props }: IRadioButtonProps) => {
  return (
    <StyledLabel className={styles.labelWrapper}>
      {labelText}
      <input type="radio" {...props} />
    </StyledLabel>
  );
};

export default RadioButton;
